/**
 * 📋 SDLC 6.3.1 UNIFIED SPECIFICATION STANDARD FILE HEADER
 * ==============================================================================
 * FILE: frontend/src/pages/landing/components/Hero.tsx
 * PURPOSE: Hero section with headline, subheadline, CTAs, and trust stats
 * SDLC FRAMEWORK VERSION: 6.1.1 (7-Pillar + 3-Section + Long-Running Agent Protocol)
 * PILLAR: P1 (Stage 06 - BUILD) + P6 (UI/UX Design)
 * SPRINT GOVERNANCE: Rule 4: Tier-3 Code Review
 *
 * DATE: 2025-12-28
 * COMPLIANCE: SDLC 6.3.1 + Token-only styling
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./Hero.module.css";

export const Hero: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.hero}>
      <div className={styles.copy}>
        <div className={styles.badge}>{t("landing.hero.badge")}</div>
        <h1 className={styles.headline}>{t("landing.hero.headline")}</h1>
        <p className={styles.subheadline}>{t("landing.hero.subheadline")}</p>

        <div className={styles.ctas}>
          <button type="button" className={styles.ctaPrimary} onClick={() => navigate("/login")}>
            {t("landing.hero.ctaPrimary")}
          </button>
          <a className={styles.ctaSecondary} href="#product">
            {t("landing.hero.ctaSecondary")}
          </a>
        </div>

        <div className={styles.stats}>
          <div className={styles.statItem}>
            <div className={styles.statValue}>{t("landing.hero.stats.branches.value")}</div>
            <div className={styles.statLabel}>{t("landing.hero.stats.branches.label")}</div>
          </div>
          <div className={styles.statDivider} />
          <div className={styles.statItem}>
            <div className={styles.statValue}>{t("landing.hero.stats.employees.value")}</div>
            <div className={styles.statLabel}>{t("landing.hero.stats.employees.label")}</div>
          </div>
        </div>
      </div>

      <div className={styles.showcase} aria-label="NQH Product Preview">
        <div className={styles.previewTop}>
          <div className={styles.previewPill} />
          <div className={styles.previewPill} />
          <div className={styles.previewPill} />
        </div>
        <div className={styles.previewGrid}>
          <div className={styles.previewCard} />
          <div className={styles.previewCard} />
          <div className={styles.previewCard} />
          <div className={styles.previewCard} />
        </div>
      </div>
    </div>
  );
};
